import csvtojson from 'csvtojson';

export const createConverter = () => csvtojson();
